import { Container } from 'unstated';
import { isEmpty } from 'validator';

export interface ILanguageDetailState {
  language: GQL.ILanguage;
  errors: IValidationErrors;
}

export interface ILanguageDetailStateProps {
  language: GQL.ILanguage;
}

export interface IValidationErrors {
  value: string | undefined;
}

export class StateContainer extends Container<ILanguageDetailState> {

  constructor(props: ILanguageDetailStateProps) {
    super();

    this.state = {
      language: props.language,
      errors: {} as IValidationErrors
    };
  }
  public async onChange(key: string, val: any) {
    await this.setState({
      language: { ...this.state.language, [key]: val }
    });
  }

  public async onChangeMany(pairs: Array<{ key: string; val: any }>) {
    for (const pair of pairs) {
      await this.onChange(pair.key, pair.val);
    }
  }

  public async validate(): Promise<IValidationErrors> {
    const { language } = this.state;
    const errors = { ...this.state.errors };
    const message = 'This field is required';

    const validateEmpty = (input: string) => {
      if (input == undefined || isEmpty(input)) {
        return message;
      } else {
        return undefined;
      }
    };

    errors.value = validateEmpty(language.value || '');
    await this.setState({ errors: errors });
    return errors;
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Languages/LanguageDetail/StateContainer.ts